import { useEffect } from 'react';
import _ from 'lodash';
import { eadmissionAPI } from '../../apis';
import { alertMsg } from '../../apis/commlogic';
import { useGetUserInfo } from '..';

const useHealthCheck = (ctrl) => {
  const userInfo = useGetUserInfo();

  const checkHealth = async () => {
    try {
      const timeout = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('請求超時')), 10000);
      });

      const response = await Promise.race([eadmissionAPI.getHealthCheck({}, { isHideLoading: true }), timeout]);

      return response;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  useEffect(() => {
    if (userInfo.hospId && ctrl) {
      const check = async () => {
        const data = await checkHealth();
        if (data.statusCode !== '0') {
          alertMsg(
            `Service interruption on Ward Place due to unexpected reason, suggest switch to contingency plan by : ${
              data?.result?.shareFolderLink ?? ''
            }`,
            _.uniqueId('warning_'),
            'error',
            null,
            false
          );
        }
      };

      check();
      const intervalId = setInterval(check, 60000);

      return () => clearInterval(intervalId);
    }
  }, [userInfo.hospId, ctrl]);
};

export default useHealthCheck;
